import { classNames } from '@panwds/tailwindcss';
/** SubNavListV3 classes */
export const flyoutMenuV3Classes = {
    generic: {
        boxSizing: 'twds-box-border'
    },
    root: {
        background: 'twds-bg-steel-gray-850',
        border: 'twds-rounded-lg',
        position: 'twds-absolute twds-left-[3.75rem]',
        fixedWidth: 'twds-w-54'
    },
    title: {
        height: 'twds-h-10',
        text: 'twds-text-steel-gray-100',
        spacing: 'twds-ml-2 twds-px-2 twds-py-2'
    },
    list: {
        style: 'twds-list-none',
        spacing: 'twds-m-0 twds-p-0 twds-pb-2',
        border: 'twds-border-0',
        dimensions: 'twds-h-full',
        overflow: 'twds-overflow-y-auto twds-overflow-x-hidden',
        scrollbar: 'twds-scrollbar-small twds-scrollbar-no-track'
    }
};
export function getFlyoutListClasses(title) {
    return classNames(flyoutMenuV3Classes.list.style, flyoutMenuV3Classes.list.spacing, flyoutMenuV3Classes.list.border, flyoutMenuV3Classes.list.dimensions, flyoutMenuV3Classes.list.overflow, flyoutMenuV3Classes.list.scrollbar, title && 'twds-py-0');
}
export function getFlyoutRootClasses() {
    return classNames(flyoutMenuV3Classes.generic.boxSizing, flyoutMenuV3Classes.root.background, flyoutMenuV3Classes.root.position, flyoutMenuV3Classes.root.border, flyoutMenuV3Classes.root.fixedWidth);
}
export function getFlyoutTitleClasses() {
    return classNames(flyoutMenuV3Classes.generic.boxSizing, flyoutMenuV3Classes.title.height, flyoutMenuV3Classes.title.text, flyoutMenuV3Classes.title.spacing);
}
//# sourceMappingURL=flyout.logic.js.map